import styled, { css } from 'styled-components';

export const AuthOtpInputCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  .otpFieldLabelClassName {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
    color: black;
  }
  .OTPTimerTextClassName {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
  }
  .resend-otp-button-away-from-timer {
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
  }
  .otp-input-box-containers {
    display: flex;
    justify-content: space-between;
  }
  .otp-input {
    max-width: 52px;
    width: unset;
    height: unset;
    margin-right: unset;
    background: transparent;
    @media (max-width: 768px) {
      max-width: 44px;
    }
  }
`;

export const AuthOtpInputCardHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
`;

export const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
  cursor: pointer;
`;

export const AuthOtpInputCardHeaderDescription = styled.div`
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
  text-align: left;
  margin-top: 32px;
  margin-bottom: 8px;
  max-width: 470px;
  text-align: left;
  color: #475569;
`;
export const OTPBoxesFieldContainerStyles = css`
  align-self: flex-start;
  width: 100%;
`;
export const CheckBoxLabelText = styled('span')`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  max-width: 400px;
`;

export const Policies = styled('a')``;

export const CantLogin = styled.span`
  color: white;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
`;

export const CantLoginButton = styled('button')`
  align-self: center;
  margin-top: 10px;
  :focus {
    outline: none;
  }
  * {
    pointer-events: none;
  }
`;

export const PhoneNumberText = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: rgb(82, 96, 109);
`;
